export default "__VITE_ASSET__934d70e8__"